<script setup lang="ts">
type Props = { item?: CommentArticle | null }

const props = withDefaults(defineProps<Props>(), { item: null })

const app = useNuxtApp()
const route = useRoute()

const toDetail = computed(() => {
  const page = route.query.page ? app.$anyToInteger(route.query.page, null) : null
  return `/imbbs?view=${props.item.id}${page !== null ? `&page=${page}` : ''}`
})

const date = () => {
  return useDayjs(props.item.created_at).format('YYYY-MM-DD HH:mm')
}
</script>

<template>
  <div class="c-imbbsItem">
    <v-icon class="c-imbbsItem_icon">
      mdi-folder-outline
    </v-icon>
    <span class="c-imbbsItem_content">
      <span class="c-imbbsItem_head">
        <span class="c-imbbsItem_title">
          <nuxt-link
            v-bind:to="toDetail"
          >
            {{ item.title }}
          </nuxt-link>
        </span>
        <span class="c-imbbsItem_sub">
          {{ item.name }}
        </span>
      </span>
      <div class="c-imbbsItem_date">
        {{ date() }}
      </div>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.c-imbbsItem {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid #ebebeb;
  color: #888;

  &:first-of-type {
    border-top: 1px solid #ebebeb;
  }

  &_icon {
    width: 24px;
    margin-top: 1px;
    margin-right: 15px;
  }

  &_content {
    flex: 1;
  }

  &_head {
    display: block;
    margin-bottom: 4px;
  }

  &_title {
    color: var(--color_primary);
    font-weight: 700;

    a {
      font-weight: 700;
    }
  }

  &_sub {
    display: inline-block;
    color: var(--color_text_base);

    &::before {
      content: "-";
      display: inline-block;
      margin: 0 10px;
    }
  }

  &_date {
    display: block;
    font-size: 14px;
  }
}
</style>
